<div style="background-image: url('assets/img/bg/white-backgroundpng.png');">
    <app-headerthree></app-headerthree>
    <app-banner></app-banner>
    <div class="section">
        <app-process></app-process>
    </div>
    <app-categories></app-categories>
    <div class="section pt-0 products-section">
        <app-products></app-products>
    </div>
    <app-testimonials></app-testimonials>
    <app-footer [layout]="classname" [logo]="ftlogo"></app-footer>
</div>